import * as React from 'react';
import { InfoAnnie } from '../InfoAnnie';
import * as Commonmark from 'react-commonmark';

interface ICancellationAnnieBanner {
  customerName: string;
  pathName: string;
}

export const CancellationAnnieBanner = ({ customerName, pathName }: ICancellationAnnieBanner) => {
  let allowCancelAnnie = false;

  const cancelAnnieMessagePaths = [
    '/account/make-a-change/cancel-policy',
    'account/make-a-change/single-trip-cancel-reason',
    'account/make-a-change/cancel-confirm',
    'account/make-a-change/cancel-renewal',
    'account/make-a-change/renewal-cancel-reason'
  ];

  cancelAnnieMessagePaths.forEach((path) => {
    if (pathName.includes(path)) {
      allowCancelAnnie = true;
    }
  });

  if (!allowCancelAnnie) {
    return null;
  }

  const cancellationText = 'We don\'t want to lose you ' + customerName + '\n\n' + 'If you\'re travelling, we\'d love to insure you.'
  return (
    <div style={{ marginBottom: '20px' }}>
      <InfoAnnie text={<Commonmark source={cancellationText}/>}/>
    </div>
  )
}
